(function () {
  angular.module('leanlaw').directive('llProductShow', productShowHideDirective('llProductShow', (me, product) => me.features[product])).directive('llProductTrialShow', productShowHideDirective('llProductTrialShow', (me, product) => me.company.products.trial || me.features[product])).directive('llProductHide', productShowHideDirective('llProductHide', (me, product) => !me.features[product]));
  function productShowHideDirective(id, show) {
    return ['userService', userService => ({
      restrict: 'A',
      scope: {
        product: `@${id}`
      },
      link: async (scope, element) => {
        element.hide();
        const me = await userService.me();
        if (show(me, scope.product)) {
          element.show();
        }
      }
    })];
  }
})();